import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $getRoot, type EditorState } from 'lexical'
import React from 'react'
import { useMaxLength } from '../hooks/use-max-length.hook'
import type { TextEditorProps } from '../text-editor.types'

type TProps = Pick<TextEditorProps, 'maxLength'>

export const CharacterCounter = ({ maxLength }: TProps) => {
  const [editor] = useLexicalComposerContext()
  const [count, setCount] = React.useState(0)

  useMaxLength({ maxLength })

  React.useEffect(() => {
    const read = (editorState: EditorState) =>
      editorState.read(() => setCount($getRoot().getTextContent().length))

    read(editor.getEditorState())
    return editor.registerUpdateListener(({ editorState }) => read(editorState))
  }, [editor])

  return maxLength != null ? (
    <div className="mt-2 form__hint">{`${maxLength - count} characters remaining`}</div>
  ) : null
}
